import React from 'react'
// @ts-expect-error @types/react-redux will be added later
import {connect} from 'react-redux'
import {Outlet, useMatch} from 'react-router'
import {toggleSidebar} from '../../../../actions/sidebar'
import {QuizHeader} from '../../../../components/header/QuizHeader'
import {ReturnButtonContainer} from '../../../../components/header/ReturnButtonContainer'
import Page from '../../../../components/page/Page'
import {SCOPE_QUIZ_BUILD} from '../../../../constants'
import {getAssignmentType} from '../../../../common/selectors/appSync'
import {isSurvey} from '../../../../common/lib/quizType'
import {Navigation} from '../Navigation'
import {ModuleNavigationButtons} from '@instructure/quiz-core'

type TeacherLayoutProps = {
  assignmentSession: Record<string, unknown> | null
  platform: string
  returnToUrl: string
  toggleSidebar: () => void
  isSurvey: boolean
  moduleNavigation?: {onPreviousItem?: () => void; onNextItem?: () => void} | null
}

function PageHeader({
  assignmentSession,
  platform,
  returnToUrl,
  toggleSidebar,
  isSurvey,
}: Omit<TeacherLayoutProps, 'moduleNavigation'>) {
  const isBuildPage = useMatch('/build/:activeAssignmentId')

  return (
    // @ts-expect-error Typescript is not fully setup in this codebase and React types are not yet handled.
    <QuizHeader
      app={isBuildPage !== null ? 'building' : 'other'}
      contextUuid={assignmentSession?.contextUuid}
      hamburgerButtonClick={isBuildPage ? toggleSidebar : null}
    >
      <Navigation isSurvey={isSurvey} />
      <ReturnButtonContainer returnToUrl={returnToUrl} platform={platform} />
    </QuizHeader>
  )
}

function BaseTeacherLayout({
  assignmentSession,
  platform,
  returnToUrl,
  toggleSidebar,
  isSurvey,
  moduleNavigation,
}: TeacherLayoutProps) {
  const isBuildPage = useMatch('/build/:activeAssignmentId')

  return (
    // @ts-expect-error Typescript is not fully setup in this codebase and React types are not yet handled.
    <Page
      header={
        <PageHeader
          assignmentSession={assignmentSession}
          platform={platform}
          returnToUrl={returnToUrl}
          toggleSidebar={toggleSidebar}
          isSurvey={isSurvey}
        />
      }
      footer={
        !isBuildPage && moduleNavigation ? (
          <ModuleNavigationButtons
            onPreviousItem={moduleNavigation?.onPreviousItem}
            onNextItem={moduleNavigation?.onNextItem}
          />
        ) : null
      }
    >
      <Outlet />
    </Page>
  )
}

// @ts-expect-error Typescript is not fully setup in this codebase and Redux types are not yet handled.
const mapStateToProps = state => {
  const assignmentType = getAssignmentType(state)
  const currentAssignmentIsSurvey = isSurvey(assignmentType)

  return {
    assignmentSession: state.assignmentSessions[SCOPE_QUIZ_BUILD] || null,
    platform: state.context.platform,
    returnToUrl: state.context.returnToUrl,
    isSurvey: currentAssignmentIsSurvey,
    moduleNavigation: state.context.moduleNavigation || null,
  }
}

export const TeacherLayout = connect(mapStateToProps, {toggleSidebar})(BaseTeacherLayout)
